module.exports = __webpack_public_path__ + "img/2-4.7a78c2e0.png";